// extracted by mini-css-extract-plugin
export var activeProgressItem = "ReactSlickController-module--activeProgressItem--1fe7d";
export var buttonsContainer = "ReactSlickController-module--buttonsContainer--13390";
export var container = "ReactSlickController-module--container--db738";
export var disabled = "ReactSlickController-module--disabled--093f5";
export var hidden = "ReactSlickController-module--hidden--82077";
export var lmsScrollbar = "ReactSlickController-module--lms-scrollbar--30296";
export var progressItem = "ReactSlickController-module--progressItem--05568";
export var sliderProgress = "ReactSlickController-module--sliderProgress--49063";
export var wrapper = "ReactSlickController-module--wrapper--8d4b6";